export default __webpack_public_path__ + "static/partnerIcon3-27b6a8e30851b74459a557d656ac6e6f.svg";